import Vue from 'vue';
import VueX from 'vuex';
import firebase from '@/firebase/init';
Vue.use(VueX);
export default new VueX.Store({
    state: {
        info: {
            restaurant: {},
            basket: null,
            method: 'pickup',
            savedDeliveryAddresses: [],
            choosedAddressIndex: null,
            when: 'asap',
            deliveryDate: null,
            paymentMethod: null,
            savedCardDetails: [],
            choosedCardIndex: null,
            products: [],
            sum: 0,
            logo: '../assets/images/sg_logo.svg',
            color: 'c12d39',
            user: {}
        }
    },
    mutations: {
        'restaurant.set': (state, data) => {
            state.info.restaurant = data.restaurant;
            //state.info.method = null;
        },
        'method.set' : (state, data) => {
            state.info.method = data.method;
        },
        'basket.set': (state, data) => {
            state.info.basket = data.basket;
        },
        'address.add': (state, data) =>{
            state.info.savedDeliveryAddresses.push(data.address);
        },
        'address.set': (state, data) => {
            state.info.choosedAddressIndex = data.index;
        },
        'when.set': (state, data) => {
            state.info.when = data.when;
        },
        'date.set': (state, data) => {
            state.info.deliveryDate = data.deliveryDate;
        },
        'paymethod.set': (state, data) => {
            state.info.paymentMethod = data.method;
        },
        'card.set': (state, data) => {
            state.info.choosedCardIndex = data.index;
        },
        'card.add': (state, data) => {
            state.info.savedCardDetails.push(data.card);
        },
        'product.add': (state, data) => {
            state.info.products.push(data.product);
        },
        'product.delete': (state, index) => {
           state.info.products.splice(index, 1);
       },
        'sum.add': (state, data) => {
            state.info.sum += data.sum;
        },
        'clear': (state) => {
            state.info.busket = null;
            state.info.method = null;
            state.info.choosedAddressIndex = null;
            state.info.when = null;
            state.info.deliveryDate = null;
            state.info.paymentMethod = null;
            state.info.choosedCardIndex = null;
            state.info.products = [];
            state.info.sum = 0;
        },
        'logo.set': (state, imageURL) => {
            state.info.logo = imageURL;
        },
        'color.set': (state, color) => {
            state.info.color = color;
        },
        'email.set': (state, data) => {
            state.info.user.emailaddress = data.emailaddress;
        },
        'user.set': (state, data) => {
            state.info.user = data.user;
        }
    }, 
    actions: {
        init({ state, commit }) {
            var db = firebase.firestore();
            db.collection("Theme").doc("mainTheme").get()
            .then(doc => {
                commit('logo.set', doc.data().logoUrl ? doc.data().logoUrl : '../assets/images/sg_logo.svg');
                commit('color.set', doc.data().color ? doc.data().color : 'c12d39');
              })
              .catch(function(error) {
                console.log(error);
              });
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js